import { useEffect, useState } from 'react';
import { useConnection, useConfig, useSwitchChain, useDisconnect } from 'wagmi';

import CloseIcon from '@/app/assets/svg/close.svg?react';
import BrokenPillarIcon from '@/app/assets/svg/wrong.svg?react';
import { Button } from '@/app/shared/ui/Button';
import { Modal } from '@/app/shared/ui/Modal';

export const WrongNetworkModal = () => {
  const [mounted, setMounted] = useState(false);

  const { isConnected, chainId } = useConnection();
  const { chains } = useConfig();
  const { mutate: switchChain, isPending } = useSwitchChain();
  const { mutate: disconnect } = useDisconnect();

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const isSupported = !isConnected || chains.some((chain) => chain.id === chainId);

  const isOpen = isConnected && !isSupported;

  const handleSwitchNetwork = () => {
    const targetChain = chains[0];
    if (targetChain) {
      switchChain({ chainId: targetChain.id });
    }
  };

  const handleClose = () => {
    disconnect();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <div className='relative flex items-center justify-center p-4'>
        <p className='text-lg font-medium text-gray-50'>Connect a Wallet</p>

        <button
          onClick={handleClose}
          className='bg-gray-850 absolute right-4 flex h-10 w-10 items-center justify-center rounded-full transition-colors hover:bg-gray-800'
        >
          <CloseIcon className='h-4 w-4' />
        </button>
      </div>

      <div className='flex flex-col items-center p-6 text-center'>
        <div className='mb-6 text-gray-500 opacity-80'>
          <BrokenPillarIcon className='h-20 w-auto' />
        </div>

        <h2 className='mb-3 text-xl font-medium text-gray-50'>Wrong Network</h2>

        <p className='mb-8 max-w-[280px] text-sm leading-relaxed text-gray-400'>
          To use Mezzanine you have to be on the Ethereum Mainnet network. Please switch network
        </p>

        <Button onClick={handleSwitchNetwork} disabled={isPending} variant='outline' className='w-full py-3.5'>
          {isPending ? 'Switching...' : 'Switch to Ethereum'}
        </Button>
      </div>
    </Modal>
  );
};
